import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { NgbProgressbar } from "@ng-bootstrap/ng-bootstrap/progressbar";

import { ActionButtonComponent } from "../../shared/action-button/action-button.component";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-master-admin",
	templateUrl: "./master-admin.component.html",
	styleUrls: ["./master-admin.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [ActionButtonComponent, NgbProgressbar]
})
export class MasterAdminComponent {
	api = inject(ApiService);

	public calcStatus: string;
	public calcProgress: number;

	public async RecalculateStates() {
		const result = await this.api.RecalculateStates(true);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.calcStatus = status;
			this.calcProgress = progress;
		});
	}
}
